module.exports = __webpack_public_path__ + "static/media/icon-advisor.a2de0c80.svg";